export default {
  preview: {
    label: 'Preview',
    tooltip: 'Preview the online ordering page in a new tab.',
  },
  buttons: {
    visit_online_store: 'Online Shop',
  },
  toasts: {
    failed_to_launch_orders_portal_app: 'Failed to launch orders portal',
  },
};
